export const MIN_DATE_RANGE = '2020-01-01'

export const CUSTOMER_GROUP_REPORT_COLUMNS = [
  {
    key: 'customer_group_name',
    label: 'Customer Group Name',
    isSorted: true,
    isSearchable: true,
    headerStyle: 'min-w-300px',
  },
  {
    key: 'total_order_count',
    label: 'Order Count',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true,
  },
  {
    key: 'total_discount',
    label: 'Discount Value',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true,
  },
  {
    key: 'contributed_discount_percentage',
    label: 'Contributed Discount (%)',
    isSorted: true,
    headerStyle: 'min-w-225px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: true,
    headerStyle: 'w-150px',
    style: 'justify-content-end',
  },
]

export const CUSTOMER_TYPE_REPORT_COLUMNS = [
  {
    key: 'customer_type',
    label: 'Customer group type',
    isSorted: true,
    isSearchable: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'total_order_count',
    label: 'Order Count',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'total_discount',
    label: 'Discount Value',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'contributed_discount_percentage',
    label: 'Contributed Discount (%)',
    isSorted: true,
    headerStyle: 'min-w-225px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: true,
    headerStyle: 'w-150px',
    style: 'justify-content-end',
  },
]

export const SALES_REP_REPORT_COLUMNS = [
  {
    key: 'rep_name',
    label: 'Sales rep name',
    isSorted: true,
    isSearchable: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'rep_type',
    label: 'Sales rep type',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'total_order_count',
    label: 'Order Count',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'total_discount',
    label: 'Discount Value',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'contributed_discount_percentage',
    label: 'Contributed Discount (%)',
    isSorted: true,
    headerStyle: 'min-w-225px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: true,
    headerStyle: 'w-100px',
    style: 'justify-content-end',
  },
]

export const SALES_REP_TYPE_REPORT_COLUMNS = [
  {
    key: 'sales_rep_type',
    label: 'Sales Rep Type',
    isSorted: true,
    isSearchable: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'total_order_count',
    label: 'Order Count',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'total_discount',
    label: 'Discount Value',
    isSorted: true,
    headerStyle: 'min-w-150px',
    isColumnTotal: true
  },
  {
    key: 'contributed_discount_percentage',
    label: 'Contributed Discount (%)',
    isSorted: true,
    headerStyle: 'min-w-225px',
  },
  {
    key: 'chart',
    label: 'Chart',
    isSorted: true,
    headerStyle: 'w-100px',
    style: 'justify-content-end',
  },
]

export const dataToCustomerGroupShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER GROUP NAME': item?.customer_group_name || '',
      'ORDER COUNT': item?.total_order_count || 0,
      'DISCOUNT VALUE': '$' + (item?.total_discount || 0),
      'CONTRIBUTED DISCOUNT (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToCustomerTypeShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'CUSTOMER TYPE': item?.customer_type || '',
      'ORDER COUNT': item?.total_order_count || 0,
      'DISCOUNT VALUE': '$' + (item?.total_discount || 0),
      'CONTRIBUTED DISCOUNT (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP': item?.rep_name || '',
      'SALES REP TYPE': item?.rep_type || '',
      'ORDER COUNT': item?.total_order_count || 0,
      'DISCOUNT VALUE': '$' + (item?.total_discount || 0),
      'CONTRIBUTED DISCOUNT (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const dataToSalesRepTypeShippingCSV = (data: any[]) => {
  const results: any[] = []

  data.forEach((item) => {
    results.push({
      'SALES REP TYPE': item?.sales_rep_type || '',
      'ORDER COUNT': item?.total_order_count || 0,
      'DISCOUNT VALUE': '$' + (item?.total_discount || 0),
      'CONTRIBUTED DISCOUNT (%)':
        item?.contributed_discount_percentage != null
          ? `${item.contributed_discount_percentage}%`
          : '0%',
    })
  })

  return results
}

export const ENTITY_PERFORMANCE_CHART_VIEW_OPTIONS = (startDate: string, endDate: string) => {
  const startDateObj = new Date(startDate)
  const endDateObj = new Date(endDate)
  const timeDiff = endDateObj.getTime() - startDateObj.getTime()
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

  if (daysDiff <= 30) {
    // Up to 1 month
    return [
      {label: 'Day', value: 'day'},
      {label: 'Week', value: 'week'},
    ]
  } else if (daysDiff <= 180) {
    // Between 1 and 6 months
    return [
      {label: 'Week', value: 'week'},
      {label: 'Month', value: 'month'},
    ]
  } else {
    // More than 6 months
    return [
      {label: 'Month', value: 'month'},
      {label: 'Year', value: 'year'},
    ]
  }
}